import { slotConstants } from "../constants";

const initialstate = {
  slotRequest: false,
  loading: false,
  slotSuccess: false,
  slotFailure: false,
  items: [],
  item: {},
  slotsRequest:false,
  counsellorListRequest: false,
  counsellorListSuccess: false,
  counsellorListFailure: false,
  myCounsellorRequest: false,
  myCounsellorSuccess: false,
  myCounsellorFailure: false,
  list: [],
  my_counsellor: [],
  slotDeleted:false
};

export function slots(state = initialstate, action) {
  switch (action.type) {
    case slotConstants.GETSLOTS_RESET:
      return {
        ...initialstate
      };
    case slotConstants.GETSLOTS_REQUEST:
      return {
        ...state,
        loading: true,
        slotRequest: true,
        slotFailure: false,
        slotSuccess: false,
        items:[]
      };
    case slotConstants.GETSLOTS_SUCCESS:
      return {
        ...state,
        slotsRequest: true,
        items: action.payload,
        loading: false,
        slotRequest: false,
        slotFailure: false,
        slotSuccess: true,
        slotDeleted:false
      };
    case slotConstants.GETSLOTS_FAILURE:
      return {
        ...state,
        loading: false,
        slotRequest: false,
        slotSuccess: false,
        slotFailure: true
      };

    case slotConstants.GET_SELECTED_SLOTS_SUCCESS: {
      return {
        ...state,
        selected_slots: action.payload
      };
    }

    case slotConstants.GET_COUNSELLOR_LIST_REQUEST:
      return {
        ...state,
        counsellorListRequest: true,
        counsellorListFailure: false,
        counsellorListSuccess: false,
        list: action.list,
      };

    case slotConstants.GET_COUNSELLOR_LIST_SUCCESS:
          return {
            ...state,
            counsellorListRequest: false,
            counsellorListFailure: false,
            counsellorListSuccess: true,
            list: action.list,
            items:[]
          };
          case slotConstants.GET_COUNSELLOR_LIST_FAILURE:
            return {
              ...state,
              counsellorListRequest: false,
              counsellorListFailure: true,
              counsellorListSuccess: false,
              list: action.list,
  };

          case slotConstants.GET_PUBLIC_COUNSELLOR_LIST_REQUEST:
            return {
              ...state,
              counsellorListRequest: true,
              counsellorListFailure: false,
              counsellorListSuccess: false,
              list: action.list,
            };
      
          case slotConstants.GET_PUBLIC_COUNSELLOR_LIST_SUCCESS:
                return {
                  ...state,
                  counsellorListRequest: false,
                  counsellorListFailure: false,
                  counsellorListSuccess: true,
                  list: action.list,
                  items:[]
                };
    case slotConstants.GET_PUBLIC_COUNSELLOR_LIST_FAILURE:
              return {
                ...state,
                counsellorListRequest: false,
                counsellorListFailure: true,
                counsellorListSuccess: false,
                list: action.list,
    };
    case slotConstants.GET_MY_COUNSELLOR_REQUEST:
      return {
        ...state,
        myCounsellorRequest: true,
        myCounsellorSuccess: false,
        myCounsellorFailure: false,
  };
    case slotConstants.GET_MY_COUNSELLOR_SUCCESS:
      return {
        ...state,
        myCounsellorRequest: false,
        myCounsellorSuccess: false,
        myCounsellorFailure: true,
        my_counsellor: action.my_counsellor,
      };
    case slotConstants.GET_MY_COUNSELLOR_FAILURE:
      return {
        ...state,
        myCounsellorRequest: false,
        myCounsellorSuccess: true,
        myCounsellorFailure: false,
        error: action.error,
    };
    case slotConstants.DELETE_SLOT_SUCCESS:
      return {
        ...state,
        slotDeleted:true
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/slots.reducer.js